var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebCameraSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#e363a8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), "className=className=className=\n\n", _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#e363a8;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.996,277.338c37.825,0,68.492-30.659,68.492-68.484c0-37.824-30.667-68.484-68.492-68.484 c-37.817,0-68.476,30.659-68.476,68.484C187.52,246.678,218.178,277.338,255.996,277.338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.026,477.183c-21.023,0-49.487-22.19-56.428-44.195c-10.013,1.359-20.219,2.132-30.602,2.132 c-10.375,0-20.581-0.772-30.602-2.132c-6.933,22.005-35.404,44.195-56.428,44.195c-25.246,0-24.385,34.817-2.042,34.817 c8.71,0,89.073,0,89.073,0s80.371,0,89.074,0C367.42,512,368.28,477.183,343.026,477.183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.996,0C140.654,0,47.142,93.505,47.142,208.853c0,115.349,93.512,208.862,208.853,208.862 c115.358,0,208.862-93.513,208.862-208.862C464.858,93.505,371.353,0,255.996,0z M255.996,110.233 c54.474,0,98.628,44.147,98.628,98.62c0,54.474-44.154,98.628-98.628,98.628c-54.466,0-98.62-44.154-98.62-98.628 C157.376,154.38,201.53,110.233,255.996,110.233z M342.166,106.912c-9.144,0-16.56-7.407-16.56-16.56 c0-9.145,7.415-16.552,16.56-16.552c9.145,0,16.552,7.407,16.552,16.552C358.718,99.504,351.31,106.912,342.166,106.912z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCameraSvgrepoCom);
export default __webpack_public_path__ + "static/media/web-camera-svgrepo-com.70866d0aea77eb661617c56ee6631e70.svg";
export { ForwardRef as ReactComponent };